<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import RushesList from './RushesList.vue';

const b = bem('rushes-page');

export default {
  data() {
    return {
      title: 'Rushes',
    };
  },
  components: {
    PageHeader,
    RushesList,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <RushesList />
</template>
